<template>
  <fragment>
    <thead>
      <tr>
        <th
          v-for="col in columns"
          :key="col.id"
          @click="sortTable(col.id)"
        >
          {{ col.display }}
          <font-awesome-icon
            :icon="['fas', 'sort']"
            class="icon alt"
          />
          <span
            v-if="col.id == sortColumn"
            :class="ascending ? 'active-down' : 'active-up'"
          >
            <font-awesome-icon
              :icon="['fas', 'sort-down']"
              class="icon alt"
            />
            <font-awesome-icon
              :icon="['fas', 'sort-up']"
              class="icon alt"
            />
          </span>
        </th>
        <th class="text-right actions">
          <span class="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="org in filteredOrganizations"
        :key="org.id"
      >
        <td>
          {{ org.name }}
          <label class="d-block d-md-none">{{ columns[0].display }}</label>
        </td>
        <router-link
          tag="td"
          class="link"
          :to="{ name: 'devices', query: { org: org.id, p: 1 } }"
        >
          {{ org.number_of_devices }}
          <label class="d-block d-md-none">{{ columns[1].display }}</label>
        </router-link>

        <router-link
          tag="td"
          class="link"
          :to="{ name: 'sites', query: { org: org.id, p: 1 } }"
        >
          {{ org.number_of_sites + 1 }}
          <label class="d-block d-md-none">{{ columns[2].display }}</label>
        </router-link>

        <td>
          <a
            :href="`mailto:${org.email_address}`"
            class="email"
          >{{ org.email_address }}</a>
          <label class="d-block d-md-none">{{ columns[3].display }}</label>
        </td>
        <td>
          <a :href="`tel:${org.phone_number_e164}`">
            +{{ org.phone_country_code | countryCallingCode }} {{ org.phone_number }}</a>
          <label class="d-block d-md-none">{{ columns[4].display }}</label>
        </td>

        <td class="actions">
          <button
            v-if="$store.getters.isAdminUser"
            v-b-tooltip.hover
            type="button"
            class="blue-hover"
            title="Edit"
            style="margin-right: 3px;"
            @click="goToEdit(org)"
          >
            <font-awesome-icon
              :icon="['fas', 'pencil']"
              class="icon alt"
            />
          </button>
          <button
            v-if="$store.getters.isKgbAdminUser && !disabledView"
            v-b-tooltip.hover
            class="red-hover"
            title="Disable"
            type="button"
            @click="goToDelete(org)"
          >
            <font-awesome-icon
              :icon="['fas', 'trash']"
              class="icon alt"
            />
          </button>
          <button
            v-if="$store.getters.isKgbAdminUser && disabledView"
            v-b-tooltip.hover
            class="blue-hover"
            title="Enable"
            type="button"
            @click="goToEnable(org)"
          >
            <font-awesome-icon
              :icon="['fas', 'plus']"
              class="icon alt"
            />
          </button>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="organizations.length > recordsPerPage">
      <tr>
        <td :colspan="columns.length + ($store.getters.isKgbAdminUser ? 1 : 0)">
          <b-pagination
            v-model="currentPage"
            :total-rows="organizations.length"
            :per-page="recordsPerPage"
            @change="pageChange"
          />
        </td>
      </tr>
    </tfoot>
  </fragment>
</template>

<script>
import paginationHelper from '../../common/paginationHelper';

/* eslint-disable vue/require-default-prop */
export default {
  name: 'OrganizationTable',
  props: {
    organizations: {
      type: Array,
    },
    showEditModal: {
      type: Function,
    },
    deleteOrg: {
      type: Function,
    },
    disabledView: {
      type: Boolean,
    },
    enableOrg: {
      type: Function,
    },
  },
  data: () => ({
    goToDevicesTimeout: null,
    loadingModal: false,

    ascending: false,
    sortColumn: '',
    columns: [{
      id: 'name', display: 'Organization',
    }, {
      id: 'number_of_devices', display: 'Devices',
    }, {
      id: 'number_of_sites', display: 'Sites',
    }, {
      id: 'email_address', display: 'Email',
    }, {
      id: 'phone_number', display: 'Phone',
    },
    ],
    currentPage: 1,
    recordsPerPage: 25,
  }),
  computed: {
    filteredOrganizations() {
      return this.organizations.slice(
        (this.currentPage - 1) * this.recordsPerPage,
        this.currentPage * this.recordsPerPage,
      ) || [];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.params': function () {
      this.handleRouteParams(this.$route.query);
    },
  },
  mounted() {
    this.handleRouteParams(this.$route.query);
  },
  methods: {
    handleRouteParams(queryParameterObject) {
      this.sortColumn = queryParameterObject.o;
      this.ascending = !!(queryParameterObject.a && queryParameterObject.a.toString() === 'true');
      this.currentPage = queryParameterObject.p || 1;
    },
    pageChange(page) {
      this.updateRoute(page, this.sortColumn, this.ascending);
    },
    updateRoute(page, column, ascending) {
      this.$router.push({
        query: { ...this.$route.query, ...paginationHelper(page, column, ascending) },
      });
    },
    sortTable: function sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }
      this.updateRoute(this.currentPage, this.sortColumn, this.ascending);


      const { ascending } = this;
      this.organizations = [...this.organizations].sort((a, b) => {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1;
        } if (a[col] < b[col]) {
          return ascending ? -1 : 1;
        }
        return 0;
      });
    },
    goToDelete(org) {
      this.deleteOrg(org);
    },
    goToEnable(org) {
      this.enableOrg(org);
    },
    goToEdit(org) {
      this.showEditModal(org);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
